import React from 'react';
import LoginForm from './LoginForm';
import Background from './Background';
import FooterLinks from './FooterLinks';
import './LoginPage.css';
import AdminLoginForm from "./AdminLoginForm";

const AdminLoginPage: React.FC = () => {
    return (
        <div className="login-page">
            <AdminLoginForm />
            <Background />
            <FooterLinks />
        </div>
    );
}

export default AdminLoginPage;